// src/api.js
import axios from 'axios';


axios.defaults.baseURL = process.env.REACT_APP_URL;
axios.defaults.withCredentials = true;

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

let csrfToken = getCookie('csrf_token');
let csrfReady = !!csrfToken;
let csrfPromise = null;

async function ensureCsrfToken() {
    if (csrfReady) return;
    if (csrfPromise) return csrfPromise;

    csrfPromise = (async () => {
        try {
            await axios.get('/csrf-token');
            csrfToken = getCookie('csrf_token');
            csrfReady = true;
        } catch (e) {
            console.warn('Gagal ambil CSRF token:', e);
        }
        csrfPromise = null;
    })();
    return csrfPromise;
}

axios.interceptors.request.use(async config => {
    if (config.url === '/csrf-token') return config;
    await ensureCsrfToken();
    if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
    }
    return config;
});

axios.interceptors.response.use(
    response => {
        const token = getCookie('csrf_token');
        if (token) csrfToken = token;
        return response;
    },
    error => {
        if (error.response?.status === 403 && error.response?.data?.msg?.includes('CSRF')) {
            csrfToken = getCookie('csrf_token');
            if (csrfToken) {
                csrfReady = true;
                return axios(error.config);
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
